export default __webpack_public_path__ + "static/media/CarouselImg2.8da062bf.png";